import { render, staticRenderFns } from "./MsNumber.vue?vue&type=template&id=294414c9&scoped=true"
import script from "./MsNumber.vue?vue&type=script&lang=js"
export * from "./MsNumber.vue?vue&type=script&lang=js"
import style0 from "./MsNumber.vue?vue&type=style&index=0&id=294414c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294414c9",
  null
  
)

export default component.exports